module.exports = __webpack_public_path__ + "img/book.a179c2d2.svg";